import request from '@meitu/saas-editor-ui/es/request';
import { getTextTemplateWebApiHostName, getWebApiHostname, getWebSiteHostname } from '@/utils/request';
import {
    IAiExpendImageTaskParams,
    IAiExpendImageTaskResponse,
    IAiModifyTaskParams,
    IAiModifyTaskResponse,
    IAiSizeExtendParams,
    IAiSizeExtendResponse,
    IAiTaskQueryParams,
    IAiTaskQueryResponse,
    ICreatePPTComponentParams,
    ICreatePPTTemplateParams,
    ICreatePPTTemplateResponse,
    IEditPPTComponentParams,
    IEditPPTTemplateParams,
    IFetchPPTComponentResponse,
    IFetchPPTTemplateResponse,
    IPPTMarkResponse,
} from './index.d';

export const AIExpendImageSource = 'image_expand';
export const AIModifyImageSource = 'image_manipulation';

/**
 * 改图
 */
export const getAiExpendImageTask = async function (params: IAiExpendImageTaskParams) {
    return await request<IAiExpendImageTaskResponse>(`${getWebApiHostname()}/v1/mtlab/internal/image_expand_async`, {
        method: 'POST',
        data: params,

        headers: {
            'Content-Type': 'application/json',
        },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/142739
 * AI 改图
 * @param params
 * @returns
 */
export const getAiModifyTask = async function (params: IAiModifyTaskParams) {
    return await request<IAiModifyTaskResponse>(`${getWebApiHostname()}/v1/mtlab/internal/image_manipulation_async`, {
        method: 'POST',

        data: params,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/122407
 * AI 扩图改图查询
 * @param params
 * @returns
 */
export const getAiTaskQuery = async function (params: IAiTaskQueryParams) {
    return await request<IAiTaskQueryResponse>(`${getWebApiHostname()}/v1/mtlab/query`, {
        method: 'GET',
        params,
        hideErrorToast: true,
    });
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157314
 * 创建ai ppt模板
 * @param params
 * @returns
 */
export const createAIPPTTemplate = async (params: ICreatePPTTemplateParams) => {
    return await request<ICreatePPTTemplateResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_template/create`,
        {
            method: 'POST',

            data: params,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157294
 * 获取ai ppt模板
 * @param params
 * @returns
 */
export const fetchAIPPTTemplateDetail = async (id: string) => {
    return await request<IFetchPPTTemplateResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_template/info`,
        {
            method: 'GET',
            params: { id },
            hideErrorToast: true,
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157306
 * 编辑ai ppt模板
 * @param params
 * @returns
 */
export const editAIPPTTemplate = async (params: IEditPPTTemplateParams) => {
    return await request<ICreatePPTTemplateResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_template/update`,
        {
            method: 'POST',

            data: params,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157286
 * 创建ai ppt组件
 * @param params
 * @returns
 */
export const createAIPPTComponent = async (params: ICreatePPTComponentParams) => {
    return await request<ICreatePPTTemplateResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_component/create`,
        {
            method: 'POST',

            data: params,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157328
 * 获取ai ppt组件
 * @param params
 * @returns
 */
export const fetchAIPPTTemplateComponent = async (id: string) => {
    return await request<IFetchPPTComponentResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_component/info`,
        {
            method: 'GET',
            params: { id },
            hideErrorToast: true,
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157294
 * 编辑ai ppt组件
 * @param params
 * @returns
 */
export const editAIPPTComponent = async (params: IEditPPTComponentParams) => {
    return await request<ICreatePPTTemplateResponse>(
        `${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_component/update`,
        {
            method: 'POST',

            data: params,
            headers: {
                'Content-Type': 'application/json',
            },
        },
    );
};

/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/157615
 * @returns
 */
export const fetchAIPPTTemplateList = async () => {
    return await request<any>(`${getWebSiteHostname()}/v2/ppt/get_change_template_data`, {
        method: 'GET',
        hideErrorToast: true,
        params: { client_id: '1189857523' },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/157614
 * @returns
 */
export const fetchAIPPTComponentList = async () => {
    return await request<any>(`${getWebSiteHostname()}/v2/ppt/component_list`, {
        method: 'GET',
        hideErrorToast: true,
        params: {
            client_id: '1189857523',
            count: 2000,
            type: 'ai_ppt_component',
        },
    });
};

export const fetchAIPPTSmartComponentList = async () => {
    return await request<any>(`${getWebSiteHostname()}/v2/ppt/component_list`, {
        method: 'GET',
        hideErrorToast: true,
        params: {
            client_id: '1189857523',
            count: 2000,
            type: 'ai_ppt_smart_component',
        },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/157314
 * @returns
 */
export const fetchAIPPTMaterialDetail = async (id: string) => {
    return await request<any>(`${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_template/info`, {
        method: 'GET',
        hideErrorToast: true,
        params: { id, client_id: '1189857523' },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2110/interface/api/113396
 * @returns
 */
export const fetchAIPPTMaterialDetailMulti = async (ids: string) => {
    return await request<any>(`${getWebApiHostname()}/v1/material/detail_multi`, {
        method: 'GET',
        hideErrorToast: true,
        params: { ids, client_id: '1189857523' },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/175010 不用放到运营侧就能获取
 * @returns
 */
export const fetchAIPPTMaterialDetailMultiV2 = async (ids: string) => {
    return await request<any>(`${getTextTemplateWebApiHostName()}/ai_material/ai_ppt_component/multi_get`, {
        method: 'GET',
        hideErrorToast: true,
        params: { ids, client_id: '1189857523' },
    });
};

/**
 * https://api-mock.meitu-int.com/project/2071/interface/api/175133
 * @returns
 */
export const getGptContent = async () => {
    return await request<any>(`${getTextTemplateWebApiHostName()}/ai_material/mock_gpt_content`, {
        method: 'GET',
        hideErrorToast: true,
        params: { client_id: '1189857523' },
    });
};

export const getPPTDynamicBackgroundList = async () => {
    return await request(`${getWebApiHostname()}/v2/ppt/background_list`, {
        method: 'GET',
        hideErrorToast: true,
        params: { client_id: '1189857523', count: 1000 },
    });
};

/**
 * 获取智能打标
 * https://api-mock.meitu-int.com/project/1289/interface/api/176105
 * @returns
 */
export const getPPTMark = async (params: { type: string; formula: string }) => {
    return await request<any>(`/seal_pie_internal/labeled.json`, {
        method: 'POST',

        data: params,
        params: { client_id: '1089867709' },
    });
};

/**
 * AI尺寸延展
 *
 * {@link https://api-mock.meitu-int.com/mock/2110/v1/mtlab/formula_auto_resize}
 * @param params - 请求参数
 */
export const getAiSizeExtend = async function (data: IAiSizeExtendParams) {
    const list = await request<IAiSizeExtendResponse>(`${getWebApiHostname()}/v1/mtlab/formula_auto_resize`, {
        method: 'POST',
        data,
        headers: {
            'Content-Type': 'application/json',
        },
    });
    return list.data.data.formulas || [];
};
